import { useCallback, useEffect, useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import api, { errMsg } from "../../lib/api";
import { PageHeader, LoadingRows } from "../../components/Shared";
import PwaSettings from "../../components/PwaSettings";

export default function StoreApp() {
  const [data, setData] = useState(null);
  const [pwa, setPwa] = useState(null);
  const [busy, setBusy] = useState(false);

  const load = useCallback(() => {
    api.get("/store-admin/pwa").then((r) => { setData(r.data); setPwa(r.data.pwa); }).catch((e) => toast.error(errMsg(e)));
  }, []);
  useEffect(() => { load(); }, [load]);

  const save = async () => {
    setBusy(true);
    try {
      const { data: r } = await api.put("/store-admin/pwa", pwa);
      setPwa(r.pwa);
      toast.success("App settings saved");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  if (!pwa || !data) return <LoadingRows rows={5} />;

  return (
    <div data-testid="store-app-page">
      <PageHeader title="App / PWA" subtitle="Turn your website into an installable app — customers get an app icon, splash screen and full-screen app experience.">
        <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs font-extrabold bg-muted">
          <Smartphone className="h-3.5 w-3.5" /> /site/{data.slug}
        </span>
      </PageHeader>
      <PwaSettings value={pwa} onChange={setPwa} onSave={save} busy={busy} storeSlug={data.slug} />
    </div>
  );
}
